import $axios from '~/plugins/axios';

import { Api, GetPrinterParams, Printer } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetPrinterParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		printerById: {} as Dict<Printer>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.printerById[id]),
		byId: (state) => (id: number) => state.printerById[id],
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_PRINTERS (state, printers: Printer[]) {
			state.printerById = { ...state.printerById, ...createDict(printers, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...printers.map((printer) => printer.id) ]));
		},
		SET_PRINTERS (state, printers: Printer[]) {
			state.printerById = { ...state.printerById, ...createDict(printers, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetPrinterParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/printer', { params });

			commit('APPEND_PRINTERS', data.payload);
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});
